import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProfilePageRoutingModule } from './profile-routing.module';

import { ProfilePage } from './profile.page';
import {Ng2SearchPipeModule} from "ng2-search-filter";
import {JwPaginationModule} from "jw-angular-pagination";
import {PaginationComponent} from "../shared/pagination/pagination.component";
import {ManageModulesComponent} from "./manage-modules/manage-modules.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ProfilePageRoutingModule,
    Ng2SearchPipeModule,
    JwPaginationModule,
    ReactiveFormsModule
  ],
    exports: [
        PaginationComponent
    ],
    declarations: [ProfilePage, PaginationComponent,ManageModulesComponent]
})
export class ProfilePageModule {}
